import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MuiPopper(theme: Theme): Components['MuiPopper'] {
  return {
    defaultProps: {
      placement: 'bottom-start',
    },
    styleOverrides: {
      root: {
        zIndex: theme.zIndex.modal,
      },
    },
  };
}
